import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, finalize, pluck, tap } from 'rxjs/operators';
import { AddIntegrationComponent } from '../../components/modals/add-integration/add-integration.component';
import { EditIntegrationComponent } from '../../components/modals/edit-integration/edit-integration.component';
import { AnyIntegration } from '../../interfaces/restaurant';
import { AuthService } from '../../services/auth/auth.service';
import { RestaurantService } from '../../services/restaurant/restaurant.service';

@UntilDestroy()
@Component({
  selector: 'app-integrations-page',
  templateUrl: './integrations-page.component.html',
  styleUrls: ['./integrations-page.component.scss']
})
export class IntegrationsPageComponent implements OnInit {

  public integrations: AnyIntegration[] = [];
  public restaurantId!: number;
  public editable = false;
  public isAvailable = false;
  public loading = true;

  constructor(
    private activateRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private restaurant: RestaurantService,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.activateRoute.parent?.data.pipe(
      pluck('restaurant'),
      tap(restaurant => {
        this.editable = !this.auth.isViewer(restaurant);
        this.restaurantId = restaurant.id;
        this.isAvailable = this.auth.isSuperAdmin();
        this.getAllIntegration();
      }),
      untilDestroyed(this),
    ).subscribe();
  }

  public addIntegration(): void {
    const addIntegration = this.matDialog.open(AddIntegrationComponent, {
      data: {
        restaurantId: this.restaurantId,
      },
    });

    addIntegration.afterClosed().pipe(
      filter((data: unknown): data is AnyIntegration => Boolean(data)),
      untilDestroyed(this),
    ).subscribe(data => {
      this.integrations = [...this.integrations, data];
    });
  }

  public getAllIntegration(): void {
    this.loading = true;
    this.restaurant.getAllIntegration(this.restaurantId).pipe(
      finalize(() => this.loading = false),
      untilDestroyed(this),
    ).subscribe((integrations: AnyIntegration[]) => {
      this.integrations = integrations;
    });
  }

  public editIntegration(integrationId: string): void {
    const editIntegration = this.matDialog.open(EditIntegrationComponent, {
      data: {
        restaurantId: this.restaurantId,
        integrationId
      },
    });

    editIntegration.afterClosed().pipe(
      filter((data: unknown): data is AnyIntegration | string => Boolean(data)),
      untilDestroyed(this),
    ).subscribe(data => {
      if (typeof data === 'string') {
        this.integrations = this.integrations
          .filter(integration => integration.id !== data);
      } else {
        this.integrations = this.integrations
          .map(integration => integration.id === data.id ? data : integration);
      }
    });
  }
}
